import React from "react";


import MessageTable from "components/Cards/MessageTable";

export default function Message() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <MessageTable />
        </div>
      </div>
    </>
  );
}
